import React from 'react'
import { Subscribe } from 'unstated'
import Notes from '../../../../../Modules/Notes/Notes'
import CourseStore from '../../../Store/CourseStore'

const CourseNotes = ({ restricted }) => {
  return (
    <Subscribe to={[CourseStore]}>
      {({
        state: {
          id,
          loading,
          loadFailed,
          userType,
          enrollments = [],
          chapters,
        },
      }) =>
        !loading && !loadFailed ? (
          <div className='notes'>
            <Notes
              type={userType}
              enrollment={enrollments.slice(-1)[0]}
              chapters={chapters}
              courseID={id}
              blockEdit={restricted}
            />
          </div>
        ) : null
      }
    </Subscribe>
  )
}

export default CourseNotes
